import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import React, { FunctionComponent } from "react";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import CustomerPersonalInfoEditor from "screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfoEditor";

const CustomerPersonalInfo: FunctionComponent = () => {
  const {
    signInNewCustomer,
    signUpCustomer
  } = OnboardingContainer.useContainer();
  const { locationName } = useAppState();
  const call = signUpCustomer();

  const handleOnSubmit = async () => {
    // TODO: add types
    const { data } = await call.signUpCustomer();
    console.log(data);
    if (data) {
      signInNewCustomer(data.signUpCustomer);
    }
  };

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Add Profile"
      centerContent
      closeButtonHandler
      clearSession
    >
      <CustomerPersonalInfoEditor
        onSubmit={handleOnSubmit}
        error={call.error}
        loading={call.loading}
        completed={call.completed}
        submitButtonText="Next"
        showCompleteLater
      />
    </PanelLayout>
  );
};

export default CustomerPersonalInfo;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfo.tsx